import { ExternalLink, Folder } from 'lucide-react';
import { useEffect, useRef, useState } from 'react';
import { frameworkService } from '~/lib/services/frameworkService';
import type { ChatHistoryItem } from '~/services/interfaceService';
import { type Framework, type Language } from '~/lib/stores/techStackSelection';

interface HistoryItemProps {
  item: ChatHistoryItem;
  onDelete?: (event: React.UIEvent) => void;
  onLoading?: () => void;
}

export function HistoryItem({ item, onDelete, onLoading }: HistoryItemProps) {
  const [hovering, setHovering] = useState(false);
  const hoverRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let timeout: NodeJS.Timeout | undefined;

    function mouseEnter() {
      setHovering(true);

      if (timeout) {
        clearTimeout(timeout);
      }
    }

    function mouseLeave() {
      setHovering(false);
    }

    hoverRef.current?.addEventListener('mouseenter', mouseEnter);
    hoverRef.current?.addEventListener('mouseleave', mouseLeave);

    return () => {
      hoverRef.current?.removeEventListener('mouseenter', mouseEnter);
      hoverRef.current?.removeEventListener('mouseleave', mouseLeave);
    };
  }, []);

  const handleClick = async (event: React.MouseEvent<HTMLDivElement>) => {
    event.preventDefault();
    onLoading?.();

    window.location.href = `/chat/${item.projectId}`;
  };

  return (
    <div
      ref={hoverRef}
      onClick={handleClick}
      className="group rounded-md hover:bg-alpha-background-tertiary overflow-hidden transition-all duration-200 cursor-pointer"
    >
      <span className="flex flex-col justify-center align-middle w-full relative px-3 py-2">
        <div className="flex justify-between items-center">
          <div className="flex items-center">
            {/* <Folder className="w-3 h-3 mr-1 text-gray-300" /> */}
            <span className="text-[13px] text-alpha-elements-textSecondary line-clamp-1">
              {item.description?.slice(0, 30)}
              {item.description && item.description.length > 30 ? '...' : ''}
            </span>
          </div>
          <div className="flex items-center gap-1">
            {item.isGitRepo && (
              <button
                className="i-ph:github-logo w-3.5 h-3.5 text-alpha-elements-textSecondary hover:text-white hover:scale-120 transition-all duration-200 hover:p-1"

                // onClick={(event) => {
                //   event.preventDefault();
                //   event.stopPropagation();
                //   window.open(
                //     `https://github.com/${item?.connections?.github?.ownerName}/${item?.connections?.github?.repoName}/tree/${item?.connections?.github?.branch}`,
                //     '_blank',
                //   );
                // }}
              />
            )}

            {/* link icon hover */}
            {hovering && (
              <div className="flex items-center text-alpha-elements-textSecondary hover:text-alpha-elements-textPrimary hover:scale-120 transition-all duration-200">
                <ExternalLink className="w-3 h-3" />
              </div>
            )}
          </div>
        </div>
      </span>
    </div>
  );
}
